import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './api';
import type { SchoolCalendar } from '../types/api';

/** Mirrors the backend's lib/calendar_dates.current_academic_year — French/most
 * European school years run September-to-July, so any date from August onward
 * already belongs to the *next* academic year's cycle. */
export function currentAcademicYear(today: Date = new Date()): string {
  const month = today.getMonth() + 1; // JS getMonth() is 0-indexed
  const startYear = month >= 8 ? today.getFullYear() : today.getFullYear() - 1;
  return `${startYear}-${startYear + 1}`;
}

export function useSchoolCalendar(country: string | undefined, enabled: boolean) {
  const academicYear = currentAcademicYear();
  return useQuery({
    queryKey: ['calendar', country, academicYear],
    queryFn: () => apiFetch<SchoolCalendar>(`/calendar/${country}/${academicYear}`),
    enabled: enabled && !!country,
    staleTime: 24 * 60 * 60 * 1000,
    retry: false,
    // Poll while the backend is still running its background fetch (see
    // lib/calendar_fetch_trigger.py) so the sheet updates from "pending" to
    // real data without the user needing to reopen it.
    refetchInterval: (query) => {
      const data = query.state.data as SchoolCalendar | undefined;
      return data?.status === 'pending' ? 4000 : false;
    },
  });
}
